import React, { useEffect,useRef,  useState } from 'react';
import axios from 'axios';
import AppStrings from '../../config/appstring'; 
import PlaceholderTypewriterInput from './PlaceHolder';
import FeesListForm from './FeesList';
import MultiTable from './Test';
import SidebarStudentMenu from './StudentOverAllDetails';
import TabMenu from './Tabmanu';
import { handleExport } from '../Print/ExportToExcel';
//import ParentComponent from './TabList';


const StudentFeesCollection = ({user}) => {
  const [data, setData] = useState([]);
  const [selectedRow, setSelectedRow] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [search, setSearch] = useState('');
  const [feeDetails, setFeeDetails] = useState([]);
  const [admissionDate, setAdmissionDate] = useState(new Date().toISOString().split('T')[0]);
  
  const [showCancelForm, setShowCancelForm] = useState(false);
const [cancelReason, setCancelReason] = useState('');
  const [cancelNotes, setCancelNotes] = useState('');
  const [mode, setMode] = useState('');

const [showSlidePanel, setShowSlidePanel] = useState(false);
const [complete, setComplete] = useState(false); 


  useEffect(() => {
console.log("Logged in as:", user?.name);
    fetchStudentData();
  }, [user]);

const slidePanelRef = useRef(null); // Ref for the slide panel div


  useEffect(() => {
    function handleClickOutside(event) {
      if (slidePanelRef.current && !slidePanelRef.current.contains(event.target)) {
        setShowSlidePanel(false);
      }
    }

    if (showSlidePanel) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showSlidePanel]);

  const fetchStudentData = async () => {
    try {
      const response = await axios.get(AppStrings.OverAllStudentDetails);
      const result = response.data.data.result || response.data.data;

      if (Array.isArray(result)) {
        setData(result);
        setError('');
      } else {
        setError('Unexpected response format');
        console.warn('Expected an array but got:', result);
      }
    } catch (err) {
      setError('Failed to fetch data');
      console.error("Fetch error:", err.message || err);
    } finally {
      setLoading(false);
    }
  };

  const handlePayClick = async (row) => {
    setMode('pay');
  };

  const handleInputChange = (index, field, value) => {
    const updated = [...feeDetails];
    updated[index][field] = value;
    setFeeDetails(updated);
  };

  const handleCancel =  async (row) => {
    setSelectedRow(null);
    setFeeDetails([]);
  };

  const totalPaid = feeDetails.reduce((sum, fee) => sum + (parseFloat(fee.current) || 0), 0);

  const getInitials = (fullName) => {
  if (!fullName) return '';
  const names = fullName.trim().split(' ');
  if (names.length === 1) return names[0][0].toUpperCase();
  return (names[0][0] + names[names.length - 1][0]).toUpperCase();
};


const colors = [
  '#4a90e2', // blue
  '#e94e77', // pinkish
  '#f6b93b', // yellow
  '#6ab04c', // green
  '#30336b', // dark blue
  '#eb4d4b', // red
  '#22a6b3', // turquoise
];

function stringToColor(str) {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  const index = Math.abs(hash) % colors.length;
  return colors[index];
}
  //  const [firstName, setFirstName] = useState("");
  //       const [lastName, setLastName] = useState("");
        
    const handleSubmit = async () => {
      const payload = {
        student: {
          id: selectedRow.STUDENT_ID,
          admissionDate: admissionDate,
          type: selectedRow.ADDFEES,
        },
        fees: feeDetails .filter(({ current, discount }) => {
          const paid = parseFloat(current) || 0;
          const off = parseFloat(discount) || 0;
          return paid + off > 0;
        }).map(({ TYPE, FEES,current, discount }) => ({
          TYPE,
          FEES,
          current,
          discount
        }))
      };
  
      try {
        console.log('haiiii');
        //const res = await fetch("https://school.agnisofterp.com/agni/testing/entry", {
          const res = await fetch(AppStrings.StudentFeesEntry, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload)
        });
  
        const result = await res.json();
        console.log('haiiii22');
        alert(result.message || "Data saved successfully!");
        handleCancel();
        fetchStudentData();
        console.log('haiiii33');
      } catch (err) {
        console.error("Error:", err);
        alert("Failed to save data.");
      }
    };

 const selectedStudent = {
    name: 'John Doe',
    class: '10-B',
    id: '1007',
    receiptNo: 'RCPT9876'
  };
const [activeForm, setActiveForm] = useState(null);
  const closeForm = () => setActiveForm(null);


  const handleTabCollectFee = async  () => {
  setShowSlidePanel(false);      // Close the slide panel
  setActiveForm('pay1');          // Open FeesListForm
 
   //setActiveForm(null);
    //setSelectedRow(null);
  //  await fetchStudentData();
};


  return (
    <div style={{ padding: '0px' }}>
      <div style={HeaderTitle}>Student List</div>

      {loading && <p>Loading data...</p>}
      {error && <p style={{ color: 'red' }}>{error}</p>}

      <div className="row">
        <div className="col-25">
          <div className="coolinput">
            <PlaceholderTypewriterInput
  value={search}
  onChange={(e) => setSearch(e.target.value)}
/>
            <br />
          </div>
        </div>
      </div>

      {!loading && !error && Array.isArray(data) && (
        <div style={{ maxHeight: '500px', overflowY: 'auto'}}>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr style={{ backgroundColor: '#f2f2f2' }}>
                 <th style={{ ...headerCellStyle, width: '20px' }}></th>
                <th style={{ ...headerCellStyle, width: '100px' }}>Name</th>
                <th style={{ ...headerCellStyle, width: '300px' }}>Parent Details</th>
                
                <th style={{ ...headerCellStyle, width: '100px' }}>Type</th>
                <th style={{ ...headerCellStyle, width: '100px' }}>Due</th>
                <th style={{ ...headerCellStyle, width: '100px' }}>Paid</th>
                <th style={{ ...headerCellStyle, width: '120px' }}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {data
                .filter((row) =>
                  row.NAME.toLowerCase().includes(search.toLowerCase()) ||
                  row.STUDENT_ID.toLowerCase().includes(search.toLowerCase())||
                  row.PARENTNAME.toLowerCase().includes(search.toLowerCase())||
                  row.PARENTMOBILE.toLowerCase().includes(search.toLowerCase())
                )
                .map((row, index) => (
                  <tr key={index}>
                      <td style={cellStyle}><div style={{ 
  ...avatarStyle, 
  backgroundColor: stringToColor(row.NAME) 
}}>
    {getInitials(row.NAME)}
  </div></td>
                    <td style={cellStyle}>
                      <div style={{ fontWeight: 'Bold'}}>
                        <button style={NameButton}
                        onClick={() => {
    setSelectedRow({ ...row, username: user?.name }); // if needed
    setShowSlidePanel(true);
  }}
                        >
    {row.NAME}
    </button>
  </div>
  <div style={{ fontSize: '10px', marginTop: '4px' }}>
    {"["+row.CLASS_SEC+"] Id : "+row.STUDENT_ID}
  </div></td>
                   
                    <td style={cellStyle}><div>
    {row.PARENTNAME}
  </div>
  <div style={{ fontSize: '10px', marginTop: '4px' }}>
    {row.PARENTMOBILE}
  </div></td>
                    <td style={cellStyle}>
                       {row.ADDFEES == 'MET' ? 'MATRIC [ '+row.TOTALDUE.toFixed(2)+' ]' : row.ADDFEES+'[ '+row.TOTALDUE.toFixed(2)+' ]'}
                      </td>
                    <td style={{ ...cellStyle, textAlign: 'center',color:'#ff5c33',fontWeight:'bold',fontSize:'15px' }}>{row.CURRENTDUE.toFixed(2)}</td>
                    <td style={{ ...cellStyle, textAlign: 'center',color:'#47d147',fontWeight:'bold',fontSize:'15px' }}>{row.TOTALPAID.toFixed(2)}</td>
                    <td style={{ ...cellStyle, textAlign: 'center' }}>
                     
<button className="GridButton" onClick={() => {
  setSelectedRow(row);         // ✅ set selected student
  setActiveForm('pay');        // ✅ open form
}}>Collect</button>


                    </td>
                  </tr>
                ))}
            </tbody>
          </table>

{activeForm === 'pay' && selectedRow && (
  <FeesListForm
    studentData={{
      name: selectedRow.NAME,
      class: selectedRow.CLASS,
      id: selectedRow.STUDENT_ID,
      receiptNo: selectedRow.RECEIPTNO || '',
      addfees:selectedRow.ADDFEES,
      username:user?.name
    }}
    onClose={async  () => {
      
   setActiveForm(null);
    setSelectedRow(null);
    await fetchStudentData();
    }}
  />
)}

{activeForm === 'pay1' && selectedRow && (
  <MultiTable
    studentData={{
      name: selectedRow.NAME,
      class: selectedRow.CLASS,
      id: selectedRow.STUDENT_ID,
      receiptNo: selectedRow.RECEIPTNO || '',
      addfees:selectedRow.ADDFEES,
      username:user?.name
    }}
    onClose={async () => {
      setActiveForm(null);
      setSelectedRow(null);
      //setFeeDetails([]);
      await fetchStudentData();
    }}
  />
)}

{showSlidePanel && selectedRow && (
  <div style={{ ...slidePanelStyle, ...slidePanelVisible }}>

     <button 
            style={closeButtonStyle}
            onClick={() => setShowSlidePanel(false)}
            aria-label="Close Slide Panel"
          >
            ✖
          </button>

 <TabMenu  key={selectedRow.STUDENT_ID}   studentData={{
  
      name: selectedRow.NAME,
      class: selectedRow.CLASS,
      id: selectedRow.STUDENT_ID,
      receiptNo: selectedRow.RECEIPTNO || '',
      addfees:selectedRow.ADDFEES,
      username:user?.name
    }}  
     onClose={() => setShowSlidePanel(false)}
  onCollectFeeClick={handleTabCollectFee} 
     />
 
    
  </div>
)}

        </div>
      )}
 
      </div>
  
  );
  
};

// Styles

const HeaderTitle={
 fontSize: '20px',
  fontWeight: 'bold',
}

const closeButtonStyle = {
  marginBottom: 10,
  padding: '6px 0px',
  background: '#fff',
  border: 'none',
  borderRadius: 4,
  cursor: 'pointer',
  color:'black',
  width:'20px'
};

const slidePanelStyle = {
  position: 'fixed',
  top: 0,
  right: 0,
  width: '50%',
  height: '100%',
  backgroundColor: '#fff',
  zIndex: 1000,
  padding: '20px',
  transform: 'translateX(100%)',  // hidden initially off screen right
  transition: 'transform 0.3s ease-in-out',
  borderTopLeftRadius: '20px',
  borderBottomLeftRadius: '20px',
  boxShadow: '-2px 0 8px rgba(0, 0, 0, 0.3)',
};

const slidePanelVisible = {
  transform: 'translateX(0%)',  // visible on screen
};

const headerCellStyle = {
//  border: '1px solid #ddd',
  padding: '8px',
  backgroundColor: '#f2f2f2',
  position: 'sticky',
  top: 0,
  zIndex: 1,
};

const cellStyle = {
  //border: '1px solid #ddd',
padding: '2px',
  fontSize:'13px',
  //  textAlign: 'center',
  // verticalAlign: 'middle',
};

const modalOverlayStyle = {
  position: 'fixed',
  top: 0, left: 0, right: 0, bottom: 0,
  backgroundColor: 'rgba(0,0,0,0.5)',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  zIndex: 9999,
};

const modalStyle = {
  backgroundColor: 'white',
  padding: '20px',
  borderRadius: '8px',
  width: '700px',
  boxShadow: '0 2px 10px rgba(0,0,0,0.3)',
  textAlign: 'center',
};


const avatarStyle = {
  width: '36px',
  height: '36px',
  backgroundColor: '#4a90e2',
  borderRadius: '50%',
  color: 'white',
  fontWeight: 'bold',
  fontSize: '14px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  margin: 'auto',
};
const NameButton = {
  width: '100%',
  height: 'auto',
  backgroundColor: 'transparent',
  color: 'black',
  textAlign: 'left',
  border: 'none',
  padding: '0',
  margin: '0',
  fontWeight: 'bold',
  cursor: 'pointer',
  fontSize:'13px'
}

// const slidePanelStyle1 = {
//   position: 'fixed',
//   top: 0,
//   right: '-100%',
//   width: '500px',
//   height: '100%',
//   backgroundColor: '#e6f7ff',
//   boxShadow: '-2px 0 10px rgba(0,0,0,0.3)',
//   padding: '20px',
//   overflowY: 'auto',
//   transition: 'right 0.3s ease-in-out',
//   zIndex: 999,
// };




export default StudentFeesCollection;
